
import { PropType } from 'vue';
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { ItemsActionNames } from '@/definitions/app/item.actions.name';
import { viewModelRepository } from '@/api/common';
import { dataModule } from '@/store/data';
import { NButton } from '@/uikit';
import { EventOrEpisode } from '@/components/events/types';
import { User } from '@/api';

@Options({
  name: 'AcknowledgeInfo',
  components: { NButton }
})
export default class AcknowledgeInfo extends Vue {
  @Prop({ type: Object as PropType<EventOrEpisode>, required: true })
  readonly item!: EventOrEpisode;

  private user?: User | null = null;

  get acknowledgedDate() {
    return this.$filters.formatDateTime(this.item.acknowledged_date);
  }

  get acknowledgedBy() {
    return this.user?.real_name;
  }

  created() {
    this.load();
  }

  @Watch('item.acknowledged_by')
  async load() {
    this.user = null;
    if (!this.item.acknowledged_by) return;
    this.user = await dataModule.usersModule.getById(this.item.acknowledged_by);
  }

  navigateToUser() {
    this.$emit('action', ItemsActionNames.NavigateToUser, this.user);
  }
}
